enum StockStatus {
  OUT_OF_STOCK = 10,
  IN_ORDER = 20,
  IN_STOCK = 30,
}

export default StockStatus;